import type { City, Country, ListRoomResponse, LoginResponse, StaffNotification, StaffNotificationTopics, State, TENANT_MODEL } from '@fitness-force/models';
import { StaffService } from '@fitness-force/api';
import { TenantService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { environment } from '@fitness-force/environments';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  AUTO_LOGIN,
  AUTO_LOGIN_COMPLETE,
  ActionTypes,
  ERROR_COMPANY_DETAILS, ERROR_TENANT_LIST, FETCHED_COMPANY_DETAILS, FETCHED_CURRENT_LOCATION, FETCHED_TENANT_BY_ID_SUCCESS, FETCHED_TENANT_LIST_SUCCESS, FETCH_APPOINTMENT_TYPE_LIST, FETCH_CITY_MASTER, FETCH_CITY_MASTER_LIST_SUCCESS, FETCH_CLASS_TYPE_LIST, FETCH_COUNTRY_MASTER, FETCH_COUNTRY_MASTER_LIST, FETCH_ROOM_LIST, FETCH_SERVICETYPE_LIST_SUCCESS, FETCH_SOURCE_STATS_LIST, FETCH_STAFF_LIST, FETCH_STAFF_LIST_ALL, FETCH_STAFF_NOTIFICATIONS, FETCH_STAGE_MASTER_SUCCESS, FETCH_TRIAL_MASTER_LIST, LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, LOGIN_WITH_GOOGLE, SELECT_LANGUAGE, SET_ACCESSED_TENANT, SET_ACCESSED_TENANT_SUCCESS, SET_ACTIVE_TENANT, SET_CLAIMS_DETAILS, SET_USER_THEME, STAFF_NOTIFICARIONS_SUCCESS, STATSIG_UPDATE_USER, STATSIG_UPDATE_USER_SUCCESS,
} from './actions';
import { catchError, map, switchMap, Observable, tap, mergeMap, withLatestFrom, skipWhile, combineLatest, debounceTime, take, EMPTY } from 'rxjs';
import { of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { CLAIMS_INFO, TENANTS_INFO, COMPANY_INFO, AUTH_STATE, LOCATION_STATE, STAFF_STATE } from './app.state';
import { AppInitService, CrispService, AppointmentTypesService, AuthSevices, CityService, ClassTypeService, CountryService, FeaturebaseService, LocationService, OpportunityStageService, RoomService, ServiceTypeService, StateService, TrialService } from '@fitness-force/api';
import { OpportunityBoardType, StaffStatus } from '@fitness-force/enum';
import { FETCH_STATE_MASTER, FETCH_STATE_MASTER_LIST_SUCCESS } from './actions/state.action';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CONSTANTS_DATA} from '@fitness-force/constants';
import { sanitizeInternalReturnUrl } from '@fitness-force/shared-utils/sanitize-return-url';
import { Location } from '@angular/common';
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { SET_ACTIVE_TENANT_DATA } from './actions/tenant.actions';
import { FeatureFlagService } from '@fitness-force/shared-utils';


@Injectable()
export class CompanyEffects {
  private appInit = inject(AppInitService);
  private tenantservice = inject(TenantService);
  private staff = inject(StaffService);
  private stageMasterService = inject(OpportunityStageService);
  private countryService = inject(CountryService);
  private appointmentTypeService = inject(AppointmentTypesService);
  private classTypeService = inject(ClassTypeService);
  private stateService = inject(StateService);
  private cityService = inject(CityService);
  private serviceTypeService = inject(ServiceTypeService);
  private roomService = inject(RoomService);
  private locationService = inject(LocationService);
  private authService = inject(AuthSevices);
  private router = inject(Router);
  private activeRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private featurebaseService = inject(FeaturebaseService);
  private featureFlagService = inject(FeatureFlagService);
  private trialService = inject(TrialService);
  private crispService = inject(CrispService);

  // Use inject() for dependencies used in class property initializers
  private actions$ = inject(Actions);
  private store = inject(Store);

  accessTenants: Array<TENANT_MODEL> = []
  selectedTenant: any;
  tenantId: any;
  tenant: any;
  selected_tenant: any;
  currentRoute: any
  country: any;
  state: any;
  city: any;
  user:any

  staffListParams = new Map();
  staffListAllParams = new Map();
  constructor() 
    {
    this.staffListParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.staffListParams.set('PageSize', { name: 'PageSize', value: 9999 });
    this.staffListParams.set('stf_status', {
      name: 'stf_status',
      value: [StaffStatus[StaffStatus.Active]],
    });
  }

  getCompanyDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('FETCHED_COMPANY_DETAILS'),
      withLatestFrom(this.store.select(COMPANY_INFO)),
      switchMap(([action, companyInfo]: any) => {
        // @ts-ignore - Service return type not properly defined
        return (localStorage.getItem('token') && companyInfo.compDetails?.uuid) ? of(companyInfo.compDetails)
          : this.appInit.getCompanyInformation();
      }),
      mergeMap((companyDetails: any) => [
        // @ts-ignore - Service return type not properly defined
        SELECT_LANGUAGE({ lang: localStorage.getItem('DEFAULT_LANGUAGE') ? JSON.parse(localStorage.getItem('DEFAULT_LANGUAGE') || '{}') : this.appInit.parseLanguage(companyDetails.primary_language) }),
        FETCHED_COMPANY_DETAILS({ companyDetails: companyDetails }),
        //FETCH_CURRENT_LOCATION()
      ]),
      catchError((err: any) => of(
        ERROR_COMPANY_DETAILS({ err: { details: { status: err.originalError.status }, status: true } }))),
       // this.router.navigateByUrl('/admin/')
    ) as any;
  });



  getTenantList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('FETCHED_TENANT_LIST'),
      // @ts-ignore - Service return type not properly defined
      switchMap(() => this.tenantservice.GetTenantList().pipe(
        map((tenantList: any) => {
          return FETCHED_TENANT_LIST_SUCCESS({ all_tenant: tenantList.items })
        }),
        catchError((err: any) => {
          console.error('Error fetching tenant list:', err);
          return of(ERROR_TENANT_LIST({ err }));
        }),
      ))
    )
  });



  getTenantListSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('FETCHED_TENANT_LIST_SUCCESS'),
      map((tenantList: any) => SET_ACCESSED_TENANT({ all_tenant: tenantList.all_tenant })),
      catchError((err) => {
        console.error('Error processing tenant list success:', err);
        return of(ERROR_TENANT_LIST({ err }));
      })
    )
  });


  setAccessTenant$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('SET_ACCESSED_TENANT'),
      withLatestFrom(this.store.select(CLAIMS_INFO)),
      skipWhile(([tenantList, data]: any) => !tenantList || tenantList.length == 0 || data == undefined || !data?.accessed_tenant),
      map(([tenantList, data,]: any) => {
        const aTenants = tenantList.all_tenant.filter((item: any) => { return data.accessed_tenant.includes((item.id).toString()) })
        return SET_ACCESSED_TENANT_SUCCESS({ accessed_tenant: aTenants })
      }),
      catchError((err) => {
        return of(ERROR_TENANT_LIST({ err }));
      }),
    )
  });


  setAccessTenantSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('SET_ACCESSED_TENANT_SUCCESS'),
      map((action: any) => {
        const TENANT_DEFAULT = localStorage.getItem('TENANT_DEFAULT');
        const queryTenantId = this.activeRoute.snapshot.queryParams['tenant'];
        let selectedTenant;
  
        // Determine the tenant ID to be used for finding the selected tenant
        const tenantIdToFind = queryTenantId && TENANT_DEFAULT == queryTenantId ? queryTenantId : TENANT_DEFAULT;
        
        // Attempt to find the selected tenant based on the determined tenant ID
        selectedTenant = action.accessed_tenant.find((t: { id: number; }) => t.id == parseInt(tenantIdToFind));
  
        // If no specific tenant ID to find, or not found, default to the first active or any tenant
        if (!selectedTenant) {
          selectedTenant = action.accessed_tenant.find((t: { status: string; }) => t.status.toLowerCase() == 'active') || action.accessed_tenant[0];
        }
  
        // Update localStorage and navigate if necessary based on the tenant's status
        if (selectedTenant && (selectedTenant.status.toLowerCase() == 'active' || selectedTenant.status.toLowerCase() == 'presales')) {
          localStorage.setItem('TENANT_DEFAULT', selectedTenant.id.toString());
        } else {
          // Navigate to 'tenant-not-found' but still dispatch SET_ACTIVE_TENANT
          this.router.navigateByUrl('tenant-not-found');
        }
        // @ts-ignore - Service return type not properly defined
        this.tenantservice.updateTenantPresaleStatus(selectedTenant);
        // Dispatch SET_ACTIVE_TENANT in all cases
        return SET_ACTIVE_TENANT({ selected_tenant: selectedTenant });
      }),
      catchError((err) => {
        return of(ERROR_TENANT_LIST({ err }));
      }),
    )
  });


  setActiveTenant$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('SET_ACTIVE_TENANT'),
      skipWhile((action: any) => !action.selected_tenant),
      switchMap((action: any) => {
        const tenant = action.selected_tenant;
        return combineLatest({
          // @ts-ignore - Service return types not properly defined
          countries: this.countryService.GetCountry(environment.BASE_URL).pipe(
            catchError((err: any) => {
              console.error('Error fetching countries:', err);
              return of([]);
            })
          ),
          // @ts-ignore - Service return types not properly defined
          stages: this.stageMasterService.OpportunityStageMasterListService(tenant.id, OpportunityBoardType.NewMemberBoard).pipe(
            catchError((err: any) => {
              console.error('Error fetching stages:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          serviceTypes: this.serviceTypeService.GetServiceType(tenant.id).pipe(
            catchError((err: any) => {
              console.error('Error fetching service types:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          classTypes: this.classTypeService.getClassTypes(tenant.id).pipe(
            catchError((err: any) => {
              console.error('Error fetching class types:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          appointmentTypes: this.appointmentTypeService.getAppointmentTypes(tenant.id, []).pipe(
            catchError((err: any) => {
              console.error('Error fetching appointment types:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          states: this.stateService.GetState(environment.BASE_URL, tenant.country).pipe(
            catchError((err: any) => {
              console.error('Error fetching states:', err);
              return of([]);
            })
          ),
          // @ts-ignore - Service return types not properly defined
          cities: this.cityService.GetCity(environment.BASE_URL, tenant.country, tenant.state).pipe(
            catchError((err: any) => {
              console.error('Error fetching cities:', err);
              return of([]);
            })
          ),
          // @ts-ignore - Service return types not properly defined
          staffList: this.staff.GetStaffList(environment.BASE_URL, tenant.id, this.getAllParams).pipe(
            catchError((err: any) => {
              console.error('Error fetching staff list:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          tenantDetails: this.tenantservice.GetTenantById(environment.BASE_URL, tenant.id).pipe(
            catchError((err: any) => {
              console.error('Error fetching tenant details:', err);
              return of(null);
            })
          ),
          // @ts-ignore - Service return types not properly defined
          staffNotifications: this.staff.StaffNotification().pipe(
            catchError((err: any) => {
              console.error('Error fetching staff notifications:', err);
              return of(null);
            })
          ),
          // @ts-ignore - Service return types not properly defined
          trials: this.trialService.getTrials(tenant.id).pipe(
            catchError((err: any) => {
              console.error('Error fetching trials:', err);
              return of({ items: [] });
            })
          ),
          // @ts-ignore - Service return types not properly defined
          sourceStats: this.appInit.getSourceStats().pipe(
            catchError((err: any) => {
              console.error('Error fetching source stats:', err);
              return of({ source: [], channel: '', total_sources: 0 });
            })
          ),
          queryParams: this.activeRoute.queryParams
        }).pipe(
          tap(() => {
            // Always update URL with selected tenant so route params stay in sync
            this.updateQueryParams(tenant.id.toString());
            localStorage.setItem('TENANT_DEFAULT', tenant.id.toString());
          }),
          map((data) => {
            const country = data.countries?.length > 0 ? this.findCountry(data.countries, tenant.country) : null;
            const state = data.states?.length > 0 ? (this.findState(data.states, tenant.state) || data.states[0]) : null;
            const city = data.cities?.length > 0 ? (this.findCity(data.cities, tenant.city) || data.cities[0]) : null;

            const actions: any[] = [
              STATSIG_UPDATE_USER({ selected_tenant: tenant }),
              SET_USER_THEME()
            ];

            // Only dispatch actions for successful API calls
            if (data.countries?.length > 0) {
              actions.push(FETCH_COUNTRY_MASTER_LIST({ countries: data.countries }));
              if (country) {
                actions.push(FETCH_COUNTRY_MASTER({ country }));
              }
            }

            if (data.stages?.items?.length > 0) {
              actions.push(FETCH_STAGE_MASTER_SUCCESS({ stages: data.stages.items }));
            }

            if (data.serviceTypes?.items?.length >= 0) {
              actions.push(FETCH_SERVICETYPE_LIST_SUCCESS({ serviceTypeList: data.serviceTypes.items }));
            }

            actions.push(
              FETCH_CLASS_TYPE_LIST({ classTypes: [...(data.classTypes?.items ?? [])] }),
            );
            actions.push(
              FETCH_APPOINTMENT_TYPE_LIST({
                appointmentTypes: [...(data.appointmentTypes?.items ?? [])],
              }),
            );

            if (data.states?.length > 0) {
              actions.push(FETCH_STATE_MASTER_LIST_SUCCESS({ states: data.states }));
              if (state) {
                actions.push(FETCH_STATE_MASTER({ state }));
              }
            }

            if (data.cities?.length > 0) {
              actions.push(FETCH_CITY_MASTER_LIST_SUCCESS({ cities: data.cities }));
              if (city) {
                actions.push(FETCH_CITY_MASTER({ city }));
              }
            }

            const staffItems = [...(data.staffList?.items ?? [])];
            actions.push(FETCH_STAFF_LIST({ staffList: staffItems }));
            actions.push(FETCH_STAFF_LIST_ALL({ staffListAll: staffItems }));

            if (data.tenantDetails) {
              actions.push(FETCHED_TENANT_BY_ID_SUCCESS({ tenant: data.tenantDetails }));
            }

            if (data.staffNotifications) {
              actions.push(FETCH_STAFF_NOTIFICATIONS({ 
                staffNotifications: data.staffNotifications, 
                companyId: tenant.company_id 
              }));
            }

            if (data.trials?.items?.length >= 0) {
              actions.push(FETCH_TRIAL_MASTER_LIST({ trials: data.trials.items }));
            }

            if (data.sourceStats && data.sourceStats.source.length > 0) {
              actions.push(FETCH_SOURCE_STATS_LIST({ sourceStats: data.sourceStats }));
            }

            return SET_ACTIVE_TENANT_DATA({ actions });
          })
        );
      }),
      catchError((err) => {
        console.error('Critical error in setActiveTenant$:', err);
        return of(ERROR_TENANT_LIST({ err }));
      })
    );
  });

  // Handle multiple actions
  handleSetActiveTenantData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SET_ACTIVE_TENANT_DATA),
      tap(({ actions }) => {
        // Dispatch each action in the array
        actions.forEach(action => this.store.dispatch(action));
      })
    );
  }, { dispatch: false });

  // Helper methods
  private updateQueryParams(tenantId: string): void {
    // Preserve current path - createUrlTree([]) would reset to root
    const urlParts = this.router.url.split('?');
    const path = urlParts[0] || '/';
    const queryAndFragment = urlParts[1] || '';
    const [queryPart, fragmentPart] = queryAndFragment.split('#');
    const params = new URLSearchParams(queryPart || '');
    params.set('tenant', tenantId);
    let newUrl = params.toString() ? `${path}?${params.toString()}` : path;
    if (fragmentPart) {
      newUrl += `#${fragmentPart}`;
    }
    this.location.go(newUrl);
  }

  private findCountry(countries: Country[], countryCode: string): Country | undefined {
    return countries.find((country: Country) => 
      String(country.three_letter_code).toLowerCase() === String(countryCode).toLowerCase() ||
      String(country.two_letter_code).toLowerCase() === String(countryCode).toLowerCase()
    );
  }

  private findState(states: State[], stateCode: string): State | undefined {
    return states.find((state: State) => 
      String(state.code).toLowerCase() === String(stateCode).toLowerCase()
    );
  }

  private findCity(cities: City[], cityCode: string): City | undefined {
    return cities.find((city: City) => 
      String(city.code).toLowerCase() === String(cityCode).toLowerCase()
    );
  }

  statsigUpdateUser$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(STATSIG_UPDATE_USER),
      debounceTime(0),
      switchMap((action) => combineLatest([
        this.store.select(AUTH_STATE),
        this.store.select(COMPANY_INFO),  
        this.store.select(LOCATION_STATE),
        this.store.select(STAFF_STATE)
      ]).pipe(
        map(([authState, company, location, staff]: any) => {
          const tenant = action.selected_tenant;
          let user:any;
          if(authState && authState.user && staff && staff.staffList && staff.staffList.length > 0)
          {
            const staffDetails = staff.staffList.find((o: any) => { return o.id === parseInt(authState.user.Id) });
            user = {
              userID: authState.user.Id,
              email: authState.user.email,
              ip: location?.ip ? location.ip : "",
              userAgent: window.navigator.userAgent,
              appVersion: "1.0",// TODO : version management (through package .json or other way. )
              custom: {
                comp_id: tenant.company_id,
                tenant_id: tenant.id,
                tenant_country: tenant.country,
                comp_purchase_portal_enable: company.compDetails.purchase_portal_enable,
                comp_member_portal_enable: company.compDetails.member_portal_enable,
                tent_pri_lang: tenant.primary_language,
                tent_sec_lang: tenant.secondary_language,
                tent_city: tenant.city,
                tent_state: tenant.state,
                tent_country: tenant.country,
                tent_status: tenant.status
              }
            }
            // @ts-ignore - Service return types not properly defined
            this.featureFlagService.updateUser(user);
            // @ts-ignore - Service return types not properly defined
            this.featurebaseService.loadFeaturebaseSDK(() => {
              // @ts-ignore - Service return types not properly defined
              this.featurebaseService.initializeChangelogWidget();
              // @ts-ignore - Service return types not properly defined
              this.featurebaseService.initializeSurveyWidget(authState.user.email);
              // @ts-ignore - Service return types not properly defined
              this.featurebaseService.identifyUser(authState.user.email,staffDetails.name, authState.user.Id, staffDetails.ff_picture ? staffDetails.ff_picture : "" , (err?: any) => {
                if (err) {
                  console.error(err);
                } else {
                  // @ts-ignore - Service return types not properly defined
                  this.featurebaseService.initializefeedbackWidget(authState.user.email);
                  console.log('User identified and data sent to Featurebase.');
                }
              });
            });

            // Initialize Crisp Chat
            // @ts-ignore - Service return types not properly defined
            this.crispService.identifyUser(authState.user.email, staffDetails.name);
            
            // Set company data with full details
            // @ts-ignore - Service return types not properly defined
            var employments:string[] = [];
            if(staffDetails.designation) {
              employments.push(staffDetails.designation);
            }
            if(staffDetails.role) {
              employments.push(staffDetails.role);
            }
            this.crispService.setCompanyData({
              name: company.compDetails?.name_primary_language || company.compDetails?.name_secondary_language,
              url: company.compDetails?.subdomain ? company.compDetails?.subdomain.split(',')[0] : tenant.domain || '',
              employment: employments
            });
            
            // Set session data
            const userCreatedDate = new Date(staffDetails.created_date);
            const currentDate = new Date();
            const daysSinceCreation = Math.floor(
              (currentDate.getTime() - userCreatedDate.getTime()) / (1000 * 60 * 60 * 24)
            );
            
            // @ts-ignore - Service return types not properly defined
            this.crispService.setSessionData({
              designation: staffDetails.designation,
              user_created_days: daysSinceCreation,
              tenant_id: tenant.id,
              company_id: tenant.company_id,
              company_name: company.compDetails?.name_primary_language || company.compDetails?.name_secondary_language,
              company_url: company.compDetails?.subdomain ? company.compDetails?.subdomain.split(',')[0] : tenant.domain || '',
              role: staffDetails.role,
              department: staffDetails.department || 'N/A',
              tenant_name: tenant.name_primary_language || tenant.name_secondary_language,
              tenant_status: tenant.status
            });
            
            // Set user avatar if available
            if (staffDetails.ff_picture) {
              // @ts-ignore - Service return types not properly defined
              this.crispService.setAvatar(staffDetails.ff_picture);
            }
            
            // Show Crisp widget after user is identified (only for authenticated users)
            // @ts-ignore - Service return types not properly defined
            this.crispService.showWidget();
          }
          return STATSIG_UPDATE_USER_SUCCESS({ user })
        }),
      )),
    );
  });
    


  // HERE WE CAN Wait for different data states to get ready
  fetchRoomList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('FETCH_ROOM_LIST'),
      withLatestFrom(this.store.select(TENANTS_INFO)),
      map((value: any) => {
        return value[1].selected_tenant;
      }),
      // @ts-ignore - Service return type not properly defined
      mergeMap((selectedTenant: any) => this.roomService.GetRoomList(selectedTenant.id)),
      map((rooms: ListRoomResponse) => {
        return (FETCH_ROOM_LIST({ rooms: rooms.items }))
      }),
      catchError((err: any) => {
        console.error('Error fetching room list:', err);
        return EMPTY;
      }),
    );
  });



  // Statsig initialization now handled by FeatureFlagService





  // push notifiction changes
  staffNotificationInitialize$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('STAFF_NOTIFiCATION_INITIALIZE'),
      tap(() => {
        const beamsClient = new PusherPushNotifications.Client({
          instanceId: environment.PUSHER_INSTANCE_ID
        });
        beamsClient
          .start()
          .then((beamsClient:any) => beamsClient.getDeviceId())
          .then((deviceId) => {
            // Successfully registered with Beams
            if (typeof window !== 'undefined' && (window as any).__DEBUG__) {
              console.log("Successfully registered with Beams. Device ID:", deviceId);
            }
          })
          .catch((error: any) => {
            // Handle permission denied errors gracefully - this is expected when notifications are disabled
            const errorName = error?.name?.toLowerCase() || '';
            const errorMessage = error?.message?.toLowerCase() || '';
            
            if (
              errorName === 'notallowederror' &&
              (errorMessage.includes('registration failed') ||
               errorMessage.includes('permission denied') ||
               errorMessage.includes('permission_denied'))
            ) {
              // Silently ignore - expected behavior when notifications are denied
              return;
            }
            
            // Log other unexpected errors
            console.error('Failed to register with Pusher Beams:', error);
          });
      }),
      catchError((err) => {
        // Only log non-permission errors
        const errorName = err?.name?.toLowerCase() || '';
        const errorMessage = err?.message?.toLowerCase() || '';
        
        if (
          errorName === 'notallowederror' &&
          (errorMessage.includes('registration failed') ||
           errorMessage.includes('permission denied') ||
           errorMessage.includes('permission_denied'))
        ) {
          // Silently ignore - expected behavior
          return EMPTY;
        }
        
        // Log other unexpected errors
        console.error('Staff notification initialization error:', err);
        return EMPTY;
      }),
    );
  }, { dispatch: false });

  // staff notification topic subscribe
  staffNotificationTopicInitialize$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FETCH_STAFF_NOTIFICATIONS),
      debounceTime(0),
        map((action: any) => {
          if(!action.staffNotifications) {
            return STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications: action.staffNotifications });
          }  
          else if(action.staffNotifications.subscribed_topics && action.staffNotifications.subscribed_topics.length > 0 
            && action.staffNotifications.subscribed_topics.filter((topic: StaffNotificationTopics) => topic.isSubscribed).length == 0)
          {
            return  STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications:action.staffNotifications });
          }
          else{
            const data = action.staffNotifications as StaffNotification;
            const beamsClient = new PusherPushNotifications.Client({
              instanceId: environment.PUSHER_INSTANCE_ID
            });
            beamsClient.start().then(() => console.log("Registered with beams!"));
            beamsClient
              .start()
              .then((beamsClient:any) => beamsClient.getDeviceId())
              .then((deviceId) =>
                console.log("Successfully registered with Beams. Device ID:", deviceId)
              )
              .then(() => {
                if(data.subscribed_topics) {  
                  const excludeTopics: any[] = ['IncomingSMS','IncomingEmail','IncomingWhatsApp'];
                  const allTopics = data.subscribed_topics.filter((topic: StaffNotificationTopics) => !excludeTopics.includes(topic.notificationSubscriptionTopic) );
                  data.tenant_ids.forEach(t => {
                    allTopics.forEach((topic : StaffNotificationTopics)=> {
                      if(topic.isSubscribed)
                         beamsClient.addDeviceInterest(`${action.companyId}_${t}_${topic.notificationSubscriptionTopic}`)
                    });
                  });
                }
                }
               )
              .then(() => beamsClient.getDeviceInterests())
              // .then((interests) => console.log("Current interests:", interests))
              .catch(console.error);
          }
          return  STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications:action.staffNotifications })
        }),
        catchError((err) => {
          console.error('Error initializing staff notification topics:', err);
          return EMPTY;
        })
    );
  });


  getCurrentLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType('FETCH_CURRENT_LOCATION'),
      // @ts-ignore - Service return type not properly defined
      mergeMap(() => {
        return this.locationService.getPosition();
      }),
      map((res: any) => {
        return (FETCHED_CURRENT_LOCATION({ location: res }))
      }),
      catchError((err: any) => {
        console.error('Error fetching current location:', err);
        return EMPTY;
      }),
    );
  });


  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LOGIN),
      switchMap((data: any) => {
        // @ts-ignore - Service return type not properly defined
        return this.authService.login(data.loginInput).pipe(
          map((response: LoginResponse) => {
            if (response.token) {
              localStorage.setItem('token', response.token);
              if (response.refresh_token) {
                localStorage.setItem('refresh_token', response.refresh_token);
              } else {
                localStorage.removeItem('refresh_token');
              }
              localStorage.setItem('auth_response', JSON.stringify(response));
            }
            // @ts-ignore - Service return type not properly defined
            const user = this.authService.decodedJwtToken(response.token);
            return LOGIN_SUCCESS({ user, token: response.token, redirect: true, auth_response: response });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(LOGIN_FAILED({ error: JSON.stringify(error) }));
          })
        );
      })
    );
  });


  loginWithGoogle$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LOGIN_WITH_GOOGLE),
      switchMap((data: any) => {
        // @ts-ignore - Service return type not properly defined
        return this.authService.socialLogin(data.loginInput).pipe(
          map((response: LoginResponse) => {
            if (response.token) {
              localStorage.setItem('token', response.token);
              if (response.refresh_token) {
                localStorage.setItem('refresh_token', response.refresh_token);
              } else {
                localStorage.removeItem('refresh_token');
              }
              localStorage.setItem('auth_response', JSON.stringify(response));
            }
            // @ts-ignore - Service return type not properly defined
            const user = this.authService.decodedJwtToken(response.token);
            return LOGIN_SUCCESS({ user, token: response.token, redirect: true, auth_response: response });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(LOGIN_FAILED({ error: JSON.stringify(error) }));
          })
        );
      })
    );
  }, { dispatch: false });

  autoLogin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AUTO_LOGIN),
      mergeMap(() => {
        // @ts-ignore - Service return types not properly defined
        const user = this.authService.decodedToken;
        if (!user) {
          return of(AUTO_LOGIN_COMPLETE());
        }

        // @ts-ignore - Service return type not properly defined
        this.authService.resetLogoutFlag();

        // @ts-ignore - Service return type not properly defined
        if (this.authService.isLoginedIn) {
          return of(LOGIN_SUCCESS({
            user: this.authService.decodedToken,
            token: localStorage.getItem('token') || '',
            redirect: false,
            auth_response: JSON.parse(localStorage.getItem('auth_response') || '{}'),
          }));
        }

        // @ts-ignore - Service return types not properly defined
        const refresh_token = this.authService.refreshTokenFromStorage;
        if (!refresh_token || refresh_token === 'null' || refresh_token.trim() === '') {
          return of(AUTO_LOGIN_COMPLETE());
        }

        // @ts-ignore - Service return type not properly defined
        return this.authService.ensureAccessTokenValid().pipe(
          switchMap((valid) => {
            if (!valid) {
              return of(AUTO_LOGIN_COMPLETE());
            }
            return of(LOGIN_SUCCESS({
              user: this.authService.decodedToken,
              token: localStorage.getItem('token') || '',
              redirect: false,
              auth_response: JSON.parse(localStorage.getItem('auth_response') || '{}'),
            }));
          }),
          catchError(() => of(AUTO_LOGIN_COMPLETE()))
        );
      })
    );
  });


  loginSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LOGIN_SUCCESS),
      tap((action: any) => {
        // Reset logout flag on successful login
        // @ts-ignore - Service return type not properly defined
        this.authService.resetLogoutFlag();
        // @ts-ignore - Service return type not properly defined
        this.store.dispatch(SET_CLAIMS_DETAILS({ claims: this.authService.parseDecodedToken }));
        this.store.dispatch({ type: 'FETCHED_TENANT_LIST' });
        this.store.dispatch({ type: 'FETCHED_COMPANY_DETAILS' });
        this.store.dispatch({ type: 'STATSIG_INITIALIZE' });
        this.store.dispatch({ type: 'STAFF_NOTIFiCATION_INITIALIZE' });
        if (action.redirect) {
          const returnUrl = this.activeRoute.snapshot.queryParamMap.get('returnUrl');
          if (returnUrl) {
            this.router.navigateByUrl(
              sanitizeInternalReturnUrl(returnUrl, CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION)
            );
          }
          else {
            this.router.navigateByUrl(CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION);
          }
        } else if (this.router.url.includes('/auth/login')) {
          const returnUrl = this.activeRoute.snapshot.queryParamMap.get('returnUrl');
          if (returnUrl) {
            this.router.navigateByUrl(returnUrl);
          }
        }

      }
      ))
  }, { dispatch: false });

  // setTheme$ = createEffect((): Observable<any> => {
  //   return this.actions$.pipe(
  //     ofType(SET_USER_THEME),
  //     tap((action: any) => {
  //       const user = this.authService.decodedToken;
  //       if(user)
  //       {
  //         this.staff.GetStaffById(user.Id).subscribe((staff: any) => {  
  //           var staffTheme = staff.theme;
  //           if(staffTheme)
  //           {
  //             var themes = THEME_CONFIG.find((theme: ThemeOption) => theme.class == staffTheme.theme_mode)!;
  //             if(themes)
  //             {
  //               var selectedTheme = themes.colors.find((color: ThemeColor) => color.themeName.toLowerCase() === staffTheme.colour.toLowerCase());
  //               if(selectedTheme)
  //                 this.store.dispatch(setTheme({ theme: selectedTheme }));
  //             }
  //           }
  //         })
  //       }
  //     })  
  //   );
  // }, { dispatch: false });


  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LOGOUT),
      tap(() => {
        // Use the AuthService logout method which sets the isLoggingOut flag
        // @ts-ignore - Service return type not properly defined
        this.authService.logout();
        
        // Clear additional data and update Statsig
        localStorage.clear();
        // @ts-ignore - Service return type not properly defined
        this.featureFlagService.updateUser(null);
        
        // Hide and reset Crisp session on logout
        // @ts-ignore - Service return type not properly defined
        this.crispService.hideWidget();
        // @ts-ignore - Service return type not properly defined
        this.crispService.resetSession();
      }),
      map(() => STATSIG_UPDATE_USER_SUCCESS({ user: null }))
    );
  });


  get getAllParams(): Array<any> {
    return [...this.staffListParams.values()];
  }

}

